import { get as _get } from 'lodash';

import { ConfigActions, ConfigActionTypes } from './config.actions';
import { DrpSearchConfig, initialState } from './config.models';

export function reducer(state = initialState, action: ConfigActions): DrpSearchConfig {
  switch (action.type) {
    case ConfigActionTypes.SET_CONFIG:
      return Object.assign({}, state, _get(action, 'payload'));

    default:
      return state;
  }
}

export const getGeoApiUrl = (state: DrpSearchConfig) => state?.geoApiUrl;
export const getclaimVendorLocationUrl = (state: DrpSearchConfig) => state?.claimVendorLocationsUrl;
